<ndt-add-closed-exception-view
   [callState]="callState | async"
   [form]="form"
   [accountId]="accountId"
   [scheduleId]="scheduleId"
   [title]="title"
   (formCanceled)="onCloseClick()"
   (formSubmitted)="onCreate()"
   (addNewPromptClick)="onAddNewPromptClick($event)"
>
</ndt-add-closed-exception-view>
